import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'

@Component({
  selector: 'se-po-organization-list-docs',
  templateUrl: './organization-list-docs.component.html',
  styleUrls: ['./organization-list-docs.component.scss'],
  standalone: false,
})
export class OrganizationListDocsComponent implements OnInit {

  public form: FormGroup
  public personaId: string | number

  public ngOnInit(): void {
    this.form = new FormGroup({
      personaId: new FormControl()
    })
  }

  public updatePersonaId(): void {
    const personaId = Number(this.form.value.personaId)
    if (!Number.isInteger(personaId)) {
      return
    }
    this.personaId = personaId
  }

}
